import { defineStore } from 'pinia';
import { SiteMapper } from '@/utils/mappers/SiteMapper';
import { defaultSiteConfiguration } from '@/data/defaultSiteConfiguration';
import { useSite } from '@/composables/api/useSite';
import OrderOption from '@/types/OrderOption';
import type { Site, SiteApi } from '@/types/Site';
import { VariantEcom } from '@/types/Product';

const siteApi = useSite();

export const useSiteStore = defineStore('site', {
    state: () => ({
        site: {} as Site,
        configuration: defaultSiteConfiguration
    }),
    actions: {
        setSite(siteData: SiteApi) {
            const mappedSite = SiteMapper.getSiteFromData(siteData);
            if (!mappedSite.screenshotBackgroundColor) {
                mappedSite.screenshotBackgroundColor = mappedSite.sceneBackgroundColor;
            }
            this.site = mappedSite;
        },
        async setConfiguration(configurationUrl: string) {
            const { data, error } = await siteApi.getSiteConfig(configurationUrl);
            if (error.value) {
                console.error('Error while fetching site configuration:', error.value);
            }
            if (data.value) {
                const fetchedConfiguration = data.value;
                this.configuration = deepMergeJson(defaultSiteConfiguration, fetchedConfiguration);
            }
        },
        isFeatureEnabled(featureName: string): boolean {
            if (!this.site.features) {
                return false;
            }
            return this.site.features.find((feature) => feature.name === featureName)?.value ?? false;
        },
        getOrderOptions(): OrderOption[] {
            return this.site?.options ?? [];
        },
        updateOrderOptionsWithPrices(variantsData: VariantEcom[]) {
            this.site.options.forEach((option) => {
                option.currentPrice = variantsData.find(
                    (variant) => variant.variantRef === option.ecommerceId
                )?.prices.currentPrice;
            });
        }
    }
});
